import React, { useContext } from "react";
import { observer } from "mobx-react";
import { CashoutType } from "@gp/hub";

import classNames from "classnames";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import MyBetsStore from "@state/stores/my-bets/MyBetsStore";
import BetDetailsStore from "@state/stores/my-bets/BetDetailsStore";
import CashoutIndicator from "@features/my-bets/shared/cashout/CashoutIndicator";
import CashoutButtonCore from "@features/my-bets/shared/cashout/CashoutButtonCore";
import { BetSlipShareDetails } from "@state/stores/my-bets/BetSlipShareDetailsStore";

export default observer(function CashoutProcessButton(props: {
	store: MyBetsStore | BetDetailsStore | BetSlipShareDetails;
}) {
	const bet = useContext(MyBetsBetContext);

	const buttonClasses = classNames(
		{
			"bet--mini__actions__btn": !WEBPACK_IS_AUTOCASHOUT_ENABLED,
			"bet--mini__btn": WEBPACK_IS_AUTOCASHOUT_ENABLED,
		},
		"btn btn--med btn--block btn--success",
		{
			"btn--icon": bet.indicator > 0 || bet.indicator < 0,
			"btn--success inc": bet.indicator > 0,
			"btn--danger desc": bet.indicator < 0,
		}
	);

	return (
		<button
			className={buttonClasses}
			type="button"
			disabled={props.store.cashoutStore.isCashoutFormSubmitting}
			onClick={() =>
				props.store.cashoutStore.openCashoutModal({
					userId: bet.userId || "",
					id: bet.id,
					displayedAmount: "",
					calculatedCashoutAmount: bet.calculatedCashoutAmount,
					cType: bet.cType || CashoutType.NO_CACHE_OUT,
					isChangeAccepted: false,
					isLive: bet.isLive,
					liveBetSlipCountdown: bet.liveBetSlipCountdown,
				})
			}
		>
			<CashoutIndicator />
			<CashoutButtonCore />
		</button>
	);
});
